import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { appName } from '../../../utils/Variables';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import { notify } from 'react-notify-toast';
import { Helmet } from "react-helmet";
import { Row, Col, Modal, Collapse, Card } from 'react-bootstrap';
import Roles from '../../../utils/Roles';
import PageTitle from '../../../containers/PageTitle';
import ReactFileReader from 'react-file-reader';
import { Cropper } from 'react-image-cropper'
import Toggle from 'react-bootstrap-toggle';
import "react-bootstrap-toggle/dist/bootstrap2-toggle.css";

const styles = {
	cardTitle: {
		paddingBottom: '5px',
		backgroundColor: '#ffd3e7',
		padding: '5px',
		fontSize: '15px',
		fontWeight: '700',
		border: '1px solid grey',
		cursor: 'pointer',
	},
	profileImg: {
		width: '190px',
		border: '1px solid grey',
	}
}

class Add extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			saveText: 'SAVE CANDIDATE',
			isRedirect: false,
			showLoader: false,
			showFullLoader: false,
			showAddModal: false,
			categories: [],
			qualifications: [],
			subjects: [],
			universities: [],
			croppedImage: '',
			openPersonalInfo: true,
			openQualificationInfo: true,
			openOtherInfo: true,
			uploadfiles: [],
			toggleActive: false,
			ifMarried: false,
			i__for: '',
			isadd: false,
			qualinfo: [],
		}

		this.onChange = this.onChange.bind(this);
		this.getSignatureFiles = this.getSignatureFiles.bind(this);
		this.handleFiles = this.handleFiles.bind(this);
		this.onToggle = this.onToggle.bind(this);
		this.onMarriedToggle = this.onMarriedToggle.bind(this);
		this.handleCropChange = this.handleCropChange.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
	}

	onRemove(index, e) {
		this.state.qualinfo.splice(index, 1);
		this.setState({ qualinfo: this.state.qualinfo });
	}

	onAdd(e) {
		this.state.qualinfo.push({ ctype: $("#i__for").val(), qualification: $("#i__qualification").val(), major: $("#i__major").val(), passyear: $("#i__passyear").val(), passmonth: $("#i__passmonth").val(), passclass: $("#i__passclass").val(), university: $("#i__university").val(), college: $("#i__college").val() });
		this.setState({ qualinfo: this.state.qualinfo, isadd: false, i__for: '' });
		$("#i__for").val('');
		$("#i__qualification").val('');
		$("#i__major").val('');
		$("#i__passyear").val('');
		$("#i__passmonth").val('');
		$("#i__passclass").val('');
		$("#i__university").val('');
		$("#i__college").val('');
	}

	onMarriedToggle(e) {
		if (e) {
			this.state.ismarried = 1;
		}
		else {
			this.state.ismarried = 0;
		}
		this.setState({ ifMarried: !this.state.ifMarried });
	}

	onToggle(e) {
		if (e) {
			this.state.iswidow = 1;
		}
		else {
			this.state.iswidow = 0;
		}
		this.setState({ toggleActive: !this.state.toggleActive });
	}

	getSignatureFiles(files) {
		this.setState({ signature: files.base64, sign: files.fileList[0]['name'] });
	}

	getFiles(files) {
		this.setState({ uploadfiles: files.base64, cername: files[0]['name'] });
	}

	catChange(e) {
		var cat = $("#i__postcategory").find(':selected').attr('data-cat');
		this.setState({ i__for: '', category: cat });
		$("#i__for").val('');
	}

	onChange(e) {
		this.setState({ [e.target.name]: e.target.value, isadd: false });
	}

	//base64 photo
	handleFiles(files) {
		this.setState({ files: files.base64, photoname: files.fileList[0]['name'], show: true });
	}

	handleCropChange(crop) {
		this.setState({ crop: crop });
	}

	handleClose() {
		this.setState({ show: false, croppedImage: this.cropper.crop() });
	}

	componentDidMount() {

		this.loadCategory();
		this.loadQualifications();
		this.loadSubjects();
		this.loadUniversity();
	}

	loadCategory() {
		this.setState({ showFullLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('postcategory/getactivecategories/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ categories: res['data'].data, showFullLoader: false });
			}
			else {
				this.setState({ showFullLoader: false });
			}
		});
	}

	loadQualifications() {
		this.setState({ showFullLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('qualification/getactivequalifications/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ qualifications: res['data'].data, showFullLoader: false });
			}
			else {
				this.setState({ showFullLoader: false });
			}
		});
	}

	loadSubjects() {
		this.setState({ showFullLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('subject/getactivesubjects/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ subjects: res['data'].data, showFullLoader: false });
			}
			else {
				this.setState({ showFullLoader: false });
			}
		});
	}

	loadUniversity() {
		this.setState({ showFullLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('university/getactiveuniversities/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ universities: res['data'].data, showFullLoader: false });
			}
			else {
				this.setState({ showFullLoader: false });
			}
		});
	}

	handleFormSubmit(e) {
		e.preventDefault();
		this.setState({ showLoader: true, saveText: 'Saving..' });
		var formData = Sanitize.objectifyForm($("#frmEmp").serializeArray());
		Reqst.axPost('employee/saveprofile', { token: Reqst.Token(formData) }).then(res => {
			if (res['data'].status == '1') {
				document.getElementById("frmEmp").reset();
				notify.show(res['data'].msg, 'success');
				this.setState({ showLoader: false, saveText: 'SAVE CANDIDATE', files: [], photoname: [], qualinfo: [] });
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false, saveText: 'SAVE CANDIDATE' });
			}
		});
	}

	getQualifiName(qid) {
		var d = this.state.qualifications;
		var val = '';
		d.map((item, i) => {
			if (item.id == qid) {
				val = item.qualification
			}
		});
		return val;
	}

	getUniversityName(uid) {
		var d = this.state.universities;
		var val = '';
		d.map((item, i) => {
			if (item.id == uid) {
				val = item.universityname
			}
		});
		return val;
	}

	render() {

		let src = (this.state.files) ? this.state.files : 'https://www.freeiconspng.com/uploads/no-image-icon-11.PNG';
		var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

		let YearList = [];
		YearList.push(<option value="">Year</option>);
		for (var i = ((new Date()).getFullYear()); i >= ((new Date()).getFullYear() - 60); i--) {
			YearList.push(<option value={i}> {i} </option>);
		}

		let dobYearList = [];
		dobYearList.push(<option value="">Year</option>);
		for (var i = ((new Date()).getFullYear() - 18); i >= ((new Date()).getFullYear() - 65); i--) {
			dobYearList.push(<option value={i}> {i} </option>);
		}

		let dobMonthList = [];
		dobMonthList.push(<option value=""> Month </option>);
		monthNames.map((item, i) => {
			dobMonthList.push(<option value={i}> {item} </option>);
		});

		let dobDateList = [];
		dobDateList.push(<option value="">Day</option>);
		for (var i = 1; i <= 31; i++) {
			dobDateList.push(<option value={i}> {i} </option>);
		}

		let cqualifications = [];
		this.state.qualifications.map((item, i) => {
			if (item.coursetype.toUpperCase() == this.state.i__for && item.coursecat == this.state.category) {
				cqualifications.push(<option value={item.id}> {item.qualification} </option>)
			}
		})

		let subject = [];
		this.state.subjects.map((item, i) => {
			if (item.coursetype.toUpperCase() == this.state.i__for) {
				subject.push(<option value={item.id}> {item.subjectname} </option>)
			}
		})

		return (
			<div>
				<Helmet>
					<title>{appName} | Candidate Registration</title>
				</Helmet>
				<PageTitle title="Candidate Registration" loading={this.state.showLoader}>
					<div className="text-right">
						{Roles.Can('candidate', 'registration', 'canuse') ?
							<Link to="/candidate/list" className="btn btn-info btn-sm" >
								<i className="fa fa-list"></i> Candidate List
						</Link> : null}

					</div>
				</PageTitle>

				<form action="" id="frmEmp" method="post" encType="multipart/form-data" onSubmit={this.handleFormSubmit}>
					<input type="hidden" name="i__lid" value={this.state.loginId} />
					<input type="hidden" name="i__company" value={this.state.companyId} />
					<input type="hidden" name="i__master" value={this.state.masterId} />
					<input type="hidden" name="i__photo" value={this.state.photoname} />
					<input type="hidden" name="i__files" value={this.state.croppedImage} />
					<input type="hidden" name="i__ismarried" value={this.state.ismarried} />
					<input type="hidden" name="i__iswidow" value={this.state.iswidow} />
					<input type="hidden" name="i__signature" value={JSON.stringify(this.state.signature)} />
					<input type="hidden" name="i__sign" value={this.state.sign} />
					<input type="hidden" name="i__qinfo" value={JSON.stringify(this.state.qualinfo)} />
					<Row>
						<Col md={{ span: 10, offset: 1 }} >
							<Card>
								<Card.Body style={{ padding: 0 }} >
									<Card.Title style={styles.cardTitle}
										onClick={() => { this.setState({ openPersonalInfo: !this.state.openPersonalInfo }) }}
										aria-controls="form-personal-info"
										aria-expanded={this.state.openPersonalInfo} >
										{this.state.openPersonalInfo ? <i className="fa fa-arrow-down"></i> : <i className="fa fa-arrow-right"></i>} Personal Info
								</Card.Title>
									<Collapse in={this.state.openPersonalInfo}>
										<div id="form-personal-info" style={{ padding: 10 }} >
											<Row>
												<Col md={9} >
													<Row>
														<Col md={3}>
															<label>Application & Register No<span className="text-danger">*</span></label>
														</Col>
														<Col md={5}>
															<div className="form-group">
																<input type="text" name="i__appno" id="i__appno" className="form-control input-sm" placeholder="Application No" required />
															</div>
														</Col>
														<Col md={4}>
															<div className="form-group">
																<input type="text" name="i__regno" id="i__regno" className="form-control input-sm" placeholder="Register No" required />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={3}>
															<label>CATEGORY OF POST <span className="text-danger">*</span></label>
														</Col>
														<Col md={9} >
															<div className="form-group" >
																<select name="i__postcategory" id="i__postcategory" className="form-control input-sm" required onChange={this.catChange.bind(this)}>
																	<option value="">Category</option>
																	{this.state.categories.map((item, i) => {
																		return (
																			<option value={item.id} data-cat={item.coursecat}>{item.categoryname}</option>
																		);
																	})}
																</select>
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={3}>
															<label>Name in Block Letters <span className="text-danger">*</span></label>
														</Col>
														<Col md={2} >
															<div className="form-group" >
																<select name="i__title" id="i__title" className="form-control input-sm" required >
																	<option value="Mr"> Mr </option>
																	<option value="Mrs"> Mrs </option>
																	<option value="Miss"> Miss </option>
																</select>
															</div>
														</Col>
														<Col md={7} >
															<div className="form-group" >
																<input type="text" name="i__name" id="i__name" className="form-control input-sm" required />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={3}>
															<label>Sex / DOB /Age <span className="text-danger">*</span></label>
														</Col>
														<Col md={2} >
															<div className="form-group" >
																<select name="i__gender" id="i__gender" className="form-control input-sm" required >
																	<option value="Male"> Male </option>
																	<option value="Female"> Female </option>
																	<option value="TG"> TG </option>
																</select>
															</div>
														</Col>
														<Col md={2} >
															<div className="form-group" >
																<select name="i__year" id="i__year" className="form-control input-sm" required >
																	{dobYearList}
																</select>
															</div>
														</Col>
														<Col md={2} style={{ padding: 0 }} >
															<div className="form-group" >
																<select name="i__month" id="i__month" className="form-control input-sm" required >
																	{dobMonthList}
																</select>
															</div>
														</Col>
														<Col md={2}>
															<div className="form-group" >
																<select name="i__day" id="i__day" className="form-control input-sm" required >
																	{dobDateList}
																</select>
															</div>
														</Col>
														<Col md={1} style={{ paddingLeft: 0 }}>
															<div className="form-group">
																<input type="text" onKeyPress={Sanitize.integerKeyPress} name="i__age" id="i__age" className="form-control input-sm" placeholder="Age" />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={3}>
															<label>Place of Birth & District <span className="text-danger">*</span></label>
														</Col>
														<Col md={5} >
															<div className="form-group" >
																<input type="text" name="i__birthplace" id="i__birthplace" className="form-control input-sm" placeholder="Birth Place" required />
															</div>
														</Col>
														<Col md={4} >
															<div className="form-group" >
																<input type="text" name="i__birthdistrict" id="i__birthdistrict" className="form-control input-sm" placeholder="Birth District" />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={3}>
															<label>Religion & Denomination </label>
														</Col>
														<Col md={5} >
															<div className="form-group" >
																<select name="i__religion" id="i__religion" className="form-control input-sm" required >
																	<option value="christian"> Christian </option>
																</select>
															</div>
														</Col>
														<Col md={4} >
															<div className="form-group" >
																<input type="text" name="i__denomination" id="i__denomination" className="form-control input-sm" placeholder="Denomination" />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={3}>
															<label>Address </label>
														</Col>
														<Col md={9}>
															<div className="form-group" >
																<textarea name="i__address" id="i__address" className="form-control input-sm" placeholder="Address" ></textarea>
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={3}>
															<label>Phone & Pincode</label>
														</Col>
														<Col md={5}>
															<div className="form-group" >
																<input type="text" name="i__phone" id="i__phone" className="form-control input-sm" placeholder="Phone" />
															</div>
														</Col>
														<Col md={4}>
															<div className="form-group" >
																<input type="text" name="i__pincode" id="i__pincode" className="form-control input-sm" placeholder="Pincode" />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={3}>
															<label>Mobile <span className="text-danger">*</span></label>
														</Col>
														<Col md={5}>
															<div className="form-group" >
																<input type="text" name="i__mobile" id="i__mobile" onKeyPress={Sanitize.integerIndMobile} className="form-control input-sm" placeholder="Mobile" required />
															</div>
														</Col>
														<Col md={4}>
															<div className="form-group" >
																<input type="text" name="i__mobile1" id="i__mobile1" className="form-control input-sm" placeholder="Mobile1" />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={3}>
															<label>Email <span className="text-danger">*</span></label>
														</Col>
														<Col md={9}>
															<input type="email" name="i__email" id="i__email" className="form-control input-sm" placeholder="Enter Valid Email" required />
														</Col>
													</Row>
												</Col>
												<Col md={3} >
													<Row>
														<Col md={12}>
															<div className="form-group">
																<ReactFileReader handleFiles={this.handleFiles} base64={true}>
																	<img src={this.state.croppedImage == '' ? "https://uae.microless.com/cdn/no_image.jpg" : this.state.croppedImage} style={styles.profileImg} />
																</ReactFileReader>
																<Modal show={this.state.show} >
																	<Modal.Body>
																		<Cropper allowNewSelection={false}
																			src={src}
																			ref={ref => { this.cropper = ref }}
																			onChange={this.handleCropChange}
																		/>
																		<button type="button" onClick={this.handleClose} >Crop</button>
																	</Modal.Body>
																</Modal>
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={12}>
															<div className="form-group">
																<label>Application Received On <span className="text-danger">*</span></label>
																<input type="date" name="i__appreceiveon" id="i__appreceiveon" className="form-control input-sm" required />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={12}>
															<div className="form-group">
																<label>Registration Year <span className="text-danger">*</span></label>
																<select name="i__foryear" id="i__foryear" className="form-control input-sm" required >
																	{YearList}
																</select>
															</div>
														</Col>
													</Row>
												</Col>
											</Row>
										</div>
									</Collapse>
								</Card.Body>
							</Card>

							<Card>
								<Card.Body style={{ padding: 0 }} >
									<Card.Title style={styles.cardTitle}
										onClick={() => { this.setState({ openQualificationInfo: !this.state.openQualificationInfo }) }}
										aria-controls="form-education-info"
										aria-expanded={this.state.openQualificationInfo} >
										{this.state.openQualificationInfo ? <i className="fa fa-arrow-down"></i> : <i className="fa fa-arrow-right"></i>} Qualification Info
								</Card.Title>
									<Collapse in={this.state.openQualificationInfo}>
										<div id="form-education-info" style={{ padding: 6 }}>
											{this.state.qualinfo.length > 0 ?
												<Row>
													<Col md={12}>
														<table width="100%" className="table table-bordered">
															<thead>
																<tr>
																	<th>S.No</th>
																	<th>Course Type</th>
																	<th>Qualification</th>
																	<th>Univeristy</th>
																	<th>College</th>
																	<th>Passing Year & Month</th>
																	<th>Passing Class</th>
																	<th></th>
																</tr>
															</thead>
															<tbody>
																{this.state.qualinfo.map((item, i) => {
																	return (
																		<tr key={i}>
																			<td>{i + 1}</td>
																			<td>{item.ctype}</td>
																			<td>{this.getQualifiName(item.qualification)}</td>
																			<td>{this.getUniversityName(item.university)}</td>
																			<td>{item.college}</td>
																			<td>{item.passyear == '' ? '-' : item.passyear} & {item.passmonth == '' ? '-' : Sanitize.getMonthName(item.passmonth)}</td>
																			<td>{item.passclass}</td>
																			<td>
																				<button type="button" className="btn btn-danger btn-xs" onClick={this.onRemove.bind(this, i)}><i className="fa fa-remove"></i></button>
																			</td>
																		</tr>
																	)
																})}
															</tbody>
														</table>
													</Col>
												</Row> : ''}
											<Row>
												<Col md={2}>
													<label>Qualification for <span className="text-danger">*</span></label>
												</Col>
												<Col md={4}>
													<div className="form-group">
														<select name="i__for" id="i__for" className="form-control input-sm" onChange={this.onChange}>
															<option value="">Select</option>
															<option value="PG">PG</option>
															<option value="UG">UG</option>
														</select>
													</div>
												</Col>
												<Col md={1}>
													<button type="button" className="btn btn-info btn-xs" onClick={() => { this.setState({ isadd: true }) }}><i className="fa fa-plus" />&nbsp;Add</button>
												</Col>
											</Row><br />
											{(this.state.i__for != '' && this.state.isadd == true) ?
												<React.Fragment>
													<Row >
														<Col md={2}>
															<label>Qualification</label>
														</Col>
														<Col md={4}>
															<div className="form-group">
																<select name="i__qualification" id="i__qualification" className="form-control input-sm" required>
																	<option value="">Qualification</option>
																	{cqualifications}
																</select>
															</div>
														</Col>
														<Col md={2}>
															<label>Major Subject</label>
														</Col>
														<Col md={4}>
															<div className="form-group">
																<select name="i__major" id="i__major" className="form-control input-sm">
																	<option value="">Major Subject</option>
																	{subject}
																</select>
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={2}>
															<label>Passing Year & Month</label>
														</Col>
														<Col md={2}>
															<div className="form-group">
																<select name="i__passyear" id="i__passyear" className="form-control input-sm" >
																	{YearList}
																</select>
															</div>
														</Col>
														<Col md={2}>
															<div className="form-group">
																<select name="i__passmonth" id="i__passmonth" className="form-control input-sm" >
																	{dobMonthList}
																</select>
															</div>
														</Col>
														<Col md={2}>
															<label>Class</label>
														</Col>
														<Col md={4}>
															<div className="form-group">
																<input type="text" name="i__passclass" id="i__passclass" className="form-control input-sm" />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={2}>
															<label>University</label>
														</Col>
														<Col md={4}>
															<div className="form-group">
																<select name="i__university" id="i__university" className="form-control input-sm">
																	<option value="">University</option>
																	{this.state.universities.map((item, i) => {
																		return (
																			<option value={item.id}>{item.universityname}</option>
																		);
																	})}
																</select>
															</div>
														</Col>
														<Col md={2}>
															<label>College Name</label>
														</Col>
														<Col md={4}>
															<div className="form-group">
																<input type="text" name="i__college" id="i__college" className="form-control input-sm" required />
															</div>
														</Col>
													</Row>
													<Row>
														<Col md={12}>
															<button type="button" style={{ float: 'right' }} className="btn btn-info btn-xs" onClick={this.onAdd.bind(this)}><i className="fa fa-plus" />&nbsp;Add</button>
														</Col>
													</Row>
												</React.Fragment> : ''}
											<Row className="post_non">
												<Col md={12}>
													<b style={{ fontSize: '16px' }}>NON GRADUATES :</b>
												</Col>
											</Row><hr className="post_non" style={{ margin: '10px' }} />
											<Row className="post_non">
												<Col md={6}>
													<Card>
														<Card.Header>
															<Card.Title>Highest Education</Card.Title>
														</Card.Header>
														<Card.Body>
															<Row>
																<Col md={4}>
																	<label>Passing Year & Month</label>
																</Col>
																<Col md={4}>
																	<div className="form-group">
																		<select name="i__hspassyear" id="i__hspassyear" className="form-control input-sm" >
																			{YearList}
																		</select>
																	</div>
																</Col>
																<Col md={4}>
																	<div className="form-group">
																		<select name="i__hspassmonth" id="i__hspassmonth" className="form-control input-sm" >
																			{dobMonthList}
																		</select>
																	</div>
																</Col>
															</Row>
															<Row>
																<Col md={4}>
																	<label>Institution Name</label>
																</Col>
																<Col md={8}>
																	<div className="form-group">
																		<input type="text" name="i__hsinstitution" id="i__hsinstitution" className="form-control input-sm" />
																	</div>
																</Col>
															</Row>
														</Card.Body>
													</Card>
												</Col>
												<Col md={6}>
													<Card>
														<Card.Header>
															<Card.Title>SSLC</Card.Title>
														</Card.Header>
														<Card.Body>
															<Row>
																<Col md={4}>
																	<label>Passing Year & Month</label>
																</Col>
																<Col md={4}>
																	<div className="form-group">
																		<select name="i__sslcpassyear" id="i__sslcpassyear" className="form-control input-sm" >
																			{YearList}
																		</select>
																	</div>
																</Col>
																<Col md={4}>
																	<div className="form-group">
																		<select name="i__sslcpassmonth" id="i__sslcpassmonth" className="form-control input-sm" >
																			{dobMonthList}
																		</select>
																	</div>
																</Col>
															</Row>
															<Row>
																<Col md={4}>
																	<label>Institution Name</label>
																</Col>
																<Col md={8}>
																	<div className="form-group">
																		<input type="text" name="i__sslcinstitution" id="i__sslcinstitution" className="form-control input-sm" />
																	</div>
																</Col>
															</Row>
														</Card.Body>
													</Card>
												</Col>
											</Row>
										</div>
									</Collapse>
								</Card.Body>
							</Card>

							<Card>
								<Card.Body style={{ padding: 0 }} >
									<Card.Title style={styles.cardTitle}
										onClick={() => { this.setState({ openOtherInfo: !this.state.openOtherInfo }) }}
										aria-controls="form-other-info"
										aria-expanded={this.state.openOtherInfo} >
										{this.state.openOtherInfo ? <i className="fa fa-arrow-down"></i> : <i className="fa fa-arrow-right"></i>} Other Info
								</Card.Title>
									<Collapse in={this.state.openOtherInfo}>
										<div id="form-other-info" style={{ padding: 6 }}>
											<Row>
												<Col md={2}>
													<label>Languages Known</label>
												</Col>
												<Col md={4}>
													<div className="form-group">
														<input type="text" name="i__language_known" id="i__language_known" className="form-control input-sm" />
													</div>
												</Col>
												<Col md={2}>
													<label>Teaching Language</label>
												</Col>
												<Col md={4}>
													<div className="form-group">
														<input type="text" name="i__teaching_language" id="i__teaching_language" className="form-control input-sm" />
													</div>
												</Col>
											</Row>
											<Row>
												<Col md={2}>
													<label>Experience</label>
												</Col>
												<Col md={4}>
													<div className="form-group">
														<input type="text" onKeyPress={Sanitize.integerKeyPress} name="i__experience" id="i__experience" className="form-control input-sm" placeholder="Experience" />
													</div>
												</Col>
												<Col md={2}>
													<label>Place of Experience</label>
												</Col>
												<Col md={4}>
													<div className="form-group">
														<input type="text" name="i__experienceplace" id="i__experienceplace" className="form-control input-sm" placeholder="Place of Experience" />
													</div>
												</Col>
											</Row>
											<Row>
												<Col md={2}>
													<label>If married, Is the wife / husband employed ?</label>
												</Col>
												<Col md={1}>
													<div className="form-group">
														<Toggle onClick={this.onMarriedToggle} on={<span>YES</span>} off={<span>NO</span>} size="xs" offstyle="danger" active={this.state.ifMarried} />
													</div>
												</Col>
												<Col md={3}>
													{this.state.ifMarried ?
														<div className="form-group">
															<input type="text" name="i__naturework" id="i__naturework" className="form-control input-sm" placeholder="Nature of work" />
														</div> : ''}
												</Col>
												{this.state.ifMarried ?
													<Col md={2}>
														<label>Place of Employment</label>
													</Col> : ''}
												{this.state.ifMarried ?
													<Col md={4}>
														<div className="form-group">
															<input type="text" name="i__empplace" id="i__empplace" className="form-control input-sm" placeholder="Place of Employment" />
														</div>
													</Col> : ''}
												<Col md={2}>
													<label>Are you a Widow?</label>
												</Col>
												<Col md={2}>
													<div className="form-group">
														<Toggle onClick={this.onToggle} on={<span>YES</span>} off={<span>NO</span>} size="xs" offstyle="danger" active={this.state.toggleActive} />
													</div>
												</Col>
												<Col md={2}>
													{/*
												<ReactFileReader handleFiles={this.getFiles.bind(this)}>
													<button className='btn btn-info btn-xs'>Upload Certificate</button>
												</ReactFileReader> */}
												</Col>
												<Col md={2}>
													<label>Signature</label>
												</Col>
												<Col md={2}>
													<div className="form-group">
														<ReactFileReader fileTypes={[".jpg", ".png", ".jpeg", ".bmp"]} base64={true} handleFiles={this.getSignatureFiles}>
															<button type="button" className='btn btn-info btn-xs'>Upload Signature</button>
														</ReactFileReader>
													</div>
												</Col>
												<Col md={2} style={{ padding: 0 }}>
													<div className="form-group">
														{this.state.sign}
													</div>
												</Col>
											</Row>
											<Row>
												<Col md={2}>
													<label>Date <span className="text-danger">*</span></label>
												</Col>
												<Col md={4}>
													<div className="form-group">
														<input type="date" name="i__date" id="i__date" className="form-control input-sm" required />
													</div>
												</Col>
												<Col md={2}>
													<label>Place <span className="text-danger">*</span></label>
												</Col>
												<Col md={4}>
													<div className="form-group">
														<input type="text" name="i__place" id="i__place" className="form-control input-sm" required />
													</div>
												</Col>
											</Row>
										</div>
									</Collapse>
								</Card.Body>
							</Card><br />
							<Row>
								<Col md={12}>
									<div className="text-right" >
										<button type="submit" className="btn btn-success btn-sm" disabled={this.state.saveText != 'SAVE CANDIDATE'} >
											<i className="fa fa-check"></i> {this.state.saveText}
										</button>
									</div>
								</Col>
							</Row>
						</Col>
					</Row>
				</form>
			</div>
		);
	}

}
export default Add;